import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { AuthService } from '../../../services/auth.service';
import { StageService } from '../../../services/stage.service';
import { ModalSaveComponent } from '../modal-save/modal-save.component';
import { ProjectManagerService } from '../../../services/project-manager.service';
import { SnapShotService } from '../../../services/snap-shot.service';
import { BuildFloorService } from '../../../services/build-floor.service';
import { DataForDisplayingMenuItemsService } from '../../../services/data-for-displaying-menu-items.service';
import { RailingGenerationService } from '../../../services/railing/services/railing-generation.service';
import { ModalStartScreenComponent } from '../modal-start-screen/modal-start-screen.component';
import { SceneryService } from '../../../services/scenery.service';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-modal-logout',
  templateUrl: './modal-logout.component.html',
  styleUrls: ['./modal-logout.component.scss']
})
export class ModalLogoutComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ModalLogoutComponent>,
    public dialog: MatDialog,
    public auth: AuthService,
    public stage: StageService,
    public projectSrvc: ProjectManagerService,
    public snapshotSrvc: SnapShotService,
    private buildFloorService: BuildFloorService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService,
    private railingGenerationService: RailingGenerationService,
    private env: SceneryService,
    private analyticsService: AnalyticsService
  ) {
    this.token = auth.getToken();
  }

  token: any;
  saveProject() {
    let dialogRef = this.dialog.open(ModalSaveComponent, {
      width: '455px',
      data: { logout: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Save/Rename dialog was closed');
      this.logout();

      let dialogRef = this.dialog.open(ModalStartScreenComponent, {
        width: '835px',
        height: '75vh',
        data: 'Data'
      });

      dialogRef.afterClosed().subscribe(result => {
        // console.log('Save/Rename dialog was closed');
      });
    });
  }

  logoutWithoutSaving() {
    this.logout();

    let dialogRef = this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Save/Rename dialog was closed');
    });
  }

  private logout(): void {
    this.projectSrvc.clearProject();
    this.auth.clearAuthorization();
    this.env.change('grid');
    this.auth.logout();
    this.snapshotSrvc.setSnapshots([]);
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('isAuthorization');
    this.buildFloorService.removeFloor();
    this.dataForDisplayingMenuItemsService.setDefaultParams();
    this.railingGenerationService.buildRailing(false);
    this.analyticsService.onUserLoggedOut();
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-logout/modal-logout.component.ts